// extracted by mini-css-extract-plugin
export default {"needMoreDays":"customCalendar_needMoreDays__y+VWq","spanNeedMoreDays":"customCalendar_spanNeedMoreDays__4PyGA"};